import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { backendDateFormat, fieldDateFormat } from '../../../constants';

const toValidMoment = (date) => {
    if (!date) return undefined;
    const value = moment.isMoment(date) ? date : moment(date);
    return value.isValid() ? value : undefined;
};

const DateFilter = ({ filterOption, filterMenu, keyParam, onFieldChange,maxDate,minDate }) => {
    const config = filterMenu[keyParam];
    const safeMinDate = toValidMoment(minDate);
    const safeMaxDate = toValidMoment(maxDate);

    return (
        <LocalizationProvider dateAdapter={AdapterMoment}>
            <DatePicker
                label={config.title}
                views={config.views || ['year', 'month', 'day']}
                format={config.format || fieldDateFormat}
                disableFuture={!!config.disableFuture}
                value={filterOption[keyParam] ? moment(filterOption[keyParam]) : null}
                onChange={(data) =>
                    onFieldChange(
                        keyParam,
                        data && moment(data)?.isValid() ? moment(data)?.format(config.format || backendDateFormat) : null
                    )
                }
                slotProps={{
                    textField: {
                        InputLabelProps: { shrink: true },
                        fullWidth: true,
                        size: 'small',
                        margin: 'normal',
                        variant: 'outlined',
                    },
                    field: {
                        clearable: true,
                        onClear: () => onFieldChange(keyParam, null),
                    },
                }}
                minDate={safeMinDate}
                maxDate={safeMaxDate}
                sx={{mt: 2.5, width: '100%', '& .MuiOutlinedInput-root': { borderRadius: '5px' } }}
            />
        </LocalizationProvider>
    );
};

export default DateFilter;
